/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Step5_ArtifactInputs */

const en_dr_step5_artifact = /** @type {(inputs: Dr_Step5_ArtifactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dot-vote (3 dots/person) + impact × effort matrix; who voted for what is recorded`)
};

const id_dr_step5_artifact = /** @type {(inputs: Dr_Step5_ArtifactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dot-vote (3 titik/orang) + matriks dampak × usaha; siapa memilih apa tercatat`)
};

/**
* | output |
* | --- |
* | "Dot-vote (3 dots/person) + impact × effort matrix; who voted for what is recorded" |
*
* @param {Dr_Step5_ArtifactInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_step5_artifact = /** @type {((inputs?: Dr_Step5_ArtifactInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Step5_ArtifactInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_step5_artifact(inputs)
	return en_dr_step5_artifact(inputs)
});